import { render, staticRenderFns } from "./TicketCategories.vue?vue&type=template&id=50d5690e&scoped=true"
import script from "./TicketCategories.vue?vue&type=script&lang=js"
export * from "./TicketCategories.vue?vue&type=script&lang=js"
import style0 from "./TicketCategories.vue?vue&type=style&index=0&id=50d5690e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d5690e",
  null
  
)

export default component.exports